import { render, staticRenderFns } from "./Theme4Contact.vue?vue&type=template&id=6096b9b1&scoped=true&"
import script from "./Theme4Contact.vue?vue&type=script&lang=js&"
export * from "./Theme4Contact.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Contact.vue?vue&type=style&index=0&id=6096b9b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096b9b1",
  null
  
)

export default component.exports